/* ---------------------------------------------------------------------------------------------------------------------
SLICK SLIDER JS
--------------------------------------------------------------------------------------------------------------------- */
jQuery(document).ready(function ($) {
    var $testimonials_slider = $('#testimonials_slider');
    if ($testimonials_slider.length !== 0) {
        $testimonials_slider.slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            dots: true,
            adaptiveHeight: true
        });
    }

    var $banners_slider = $('#banners_slider');
    if ($banners_slider.length !== 0) {
        $banners_slider.slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            fade: true,
            slidesToShow: 1,
            dots: false,
            arrows:false
        });
    }
});
